module.exports = __webpack_public_path__ + "img/domestic-2001-party-newspaper.0ddee168.jpg";